<script setup lang="ts">

import Dashboard from "@/components/WiserDashboardComponent.vue";
</script>

<template>
  <Dashboard />
  <div class="container">

  </div>
</template>

<style scoped>

</style>
